import styled from 'styled-components'

const MobileMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export default MobileMenuWrapper
